<rma-simple-layout [cssClass]="'simple-layout-wrapper login-background'" [showLanguageSelector]=false>
  <div class="simple-layout-container-lg client-creation">
    <div class="card">
      <button class="close cancel-client-creation-icon" (click)="cancelClientCreation()">
        <fa-icon [icon]="['fas', 'times']"
                 class="text-muted"></fa-icon>
      </button>
      <div class="card-body">

        <rma-loading [type]="'wheel'" [isLoading]="isLoading$ | async" [fadeOnly]="true">
        <form [formGroup]="clientCreationForm">
          <p-stepper [value]="activeStep" [linear]="true" class="client_creation_stepper">
            <p-step-list>
              <p-step [value]="0" >
                <fa-icon [icon]="['fas', 'address-card']"
                         size="2x"
                         class="text-normal"></fa-icon>
              </p-step>
              <p-step [value]="1">
                <fa-icon [icon]="['fas', 'file-invoice-dollar']"
                         size="2x"
                         class="text-normal"></fa-icon>
              </p-step>
              <p-step [value]="2">
                <fa-icon [icon]="['fas', 'clipboard-list-check']"
                         size="2x"
                         class="text-normal"></fa-icon>
              </p-step>
              <p-step [value]="3">
                <fa-icon [icon]="['fas', 'file-contract']"
                         size="2x"
                         class="text-normal"></fa-icon>
              </p-step>
            </p-step-list>
            <p-step-panels>
              <p-step-panel [value]="0">
                <ng-template #content>
                  <ibp-company-info-step (nextCallback)="activeStep = 1"
                                         (cancelCallback)="cancelClientCreation()"></ibp-company-info-step>
                </ng-template>
              </p-step-panel>
              <p-step-panel [value]="1">
                <ng-template #content>
                  <ibp-accounting-info-step (prevCallback)="activeStep = 0"
                                            (nextCallback)="activeStep = 2"></ibp-accounting-info-step>
                </ng-template>
              </p-step-panel>
              <p-step-panel [value]="2">
                <ng-template #content>
                  <ibp-service-info-step (prevCallback)="activeStep = 1"
                                         (nextCallback)="activeStep = 3"></ibp-service-info-step>
                </ng-template>
              </p-step-panel>
              <p-step-panel [value]="3">
                <ng-template #content>
                  <ibp-summary-step (prevCallback)="activeStep = 2"
                                    (submitClientCallback)="submitClient()"></ibp-summary-step>
                </ng-template>
              </p-step-panel>
            </p-step-panels>
          </p-stepper>
        </form>
        </rma-loading>
      </div>
    </div>
  </div>
</rma-simple-layout>
